import { Component, OnInit } from '@angular/core';
import { BackToHomeComponent } from '../../components/back-to-home/back-to-home.component';
import { RouterLink, Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { RecaptchaV3Service } from '../../core/services/recaptcha/recaptcha-v3-service';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import {UserSelfService} from '../../core/services/user/user-self.service';

@Component({
  selector: 'app-forgot-password',
  imports: [
    BackToHomeComponent,
    RouterLink,
    ReactiveFormsModule,
    TranslateModule,
    CommonModule
  ],
  templateUrl: './forgot-password.component.html',
  styleUrl: './forgot-password.component.scss'
})
export class ForgotPasswordComponent implements OnInit {
  forgotPasswordForm!: FormGroup;
  isLoading = false;
  errorMessage = '';
  successMessage = '';
  lastRequestTime = 0;
  cooldownRemaining = 0;
  cooldownInterval: any;

  constructor(
    private readonly formBuilder: FormBuilder,
    private readonly userSelfService: UserSelfService,
    private readonly recaptchaService: RecaptchaV3Service,
    private readonly router: Router
  ) {}

  ngOnInit(): void {
    this.initForm();
  }

  initForm(): void {
    this.forgotPasswordForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]]
    });
  }

  onSubmit(): void {
    if (this.forgotPasswordForm.invalid) {
      return;
    }

    // Check if we're in cooldown period (60 seconds)
    const now = Date.now();
    if (this.lastRequestTime > 0 && now - this.lastRequestTime < 60000) {
      this.cooldownRemaining = Math.ceil((60000 - (now - this.lastRequestTime)) / 1000);
      this.startCooldownTimer();
      this.errorMessage = `Please wait ${this.cooldownRemaining} seconds before requesting another code.`;
      return;
    }

    this.isLoading = true;
    this.errorMessage = '';
    this.successMessage = '';

    const { email } = this.forgotPasswordForm.value;

    this.recaptchaService.execute('forgot_password', (recaptchaToken) => {
      this.userSelfService.forgotPassword(email, recaptchaToken).subscribe({
        next: () => {
          this.isLoading = false;
          this.lastRequestTime = Date.now();
          // Navigate to reset-password page with email as query parameter
          this.router.navigate(['/reset-password'], {
            queryParams: { email: email }
          });
        },
        error: (error) => {
          this.isLoading = false;
          this.errorMessage = error.message;
        }
      });
    });
  }

  startCooldownTimer(): void {
    if (this.cooldownInterval) {
      clearInterval(this.cooldownInterval);
    }

    this.cooldownRemaining = 60;
    this.cooldownInterval = setInterval(() => {
      this.cooldownRemaining--;
      if (this.cooldownRemaining <= 0) {
        clearInterval(this.cooldownInterval);
      }
    }, 1000);
  }

  ngOnDestroy(): void {
    if (this.cooldownInterval) {
      clearInterval(this.cooldownInterval);
    }
  }
}
